import RefreshAllIcon from '@mui/icons-material/Refresh';
import { Button, Card, CardContent } from '@mui/material';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import SectionTitle from 'components/common/SectionTitle';
import toast from 'features/toast';
import { axiosPrivate } from 'services/axios';
import { lmToSAPQueueService } from 'services/api';
import { LMToSAPQueueColumns } from './LMToSAPQueueColumns';

export const LMToSAPQueueGrid = () => {
  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const handleRefreshAll = () => {
    axiosPrivate
      .post('lm-to-sap/poll-pending/')
      .then((res) => {
        toast.success(t('entities.sap-settings.poll_enqueued', { task: res.data.task }));
      })
      .catch((e) => {
        toast.error(e.message);
      });
  };

  return (
    <Card className="mt-6">
      <CardContent>
        <div className="flex justify-between items-center mb-4">
          <SectionTitle>{t('entities.sap-settings.queue_title')}</SectionTitle>
          <Button
            variant="contained"
            size="small"
            startIcon={<RefreshAllIcon />}
            onClick={handleRefreshAll}>
            {t('entities.sap-settings.refresh_all')}
          </Button>
        </div>
        <EnhancedDataGrid
          columns={LMToSAPQueueColumns(datagridRefresh)}
          service={lmToSAPQueueService}
          refresh={datagridRefresh}
          disableDelete={true}
          disableEdit={true}
        />
      </CardContent>
    </Card>
  );
};

export default LMToSAPQueueGrid;
